import React, {
  useContext,
  useState,
  createContext,
  useEffect,
  useCallback,
} from "react";
import {
  ILanguage,
  IMenuData,
  IMainProps,
  // INewMenuItem,
  IFilterData,
  INewMenuItem,
} from "../@types/types";
import {
  requestERPLYData,
  createLanguageData,
  addNewMenuItem,
  flatenArray,
  createStyle,
} from "../utils";
// import GBFlag from "../components/icons/GB.svg";
// import EEFlag from "../components/icons/EE.svg";
// import FIFlag from "../components/icons/FI.svg";
// import RUFlag from "../components/icons/RU.svg";
import FeatherIcon from "feather-icons-react";
import useTheme, { Theme, Mode } from "../hooks/useTheme";

const partnerKey = "48452def9c79dfa6b0434567001a0bf2ab64d68e";

export const refreshState = {
  MAIN: "MAIN",
  RELOAD: "RELOAD",
  REFRESH: "REFRESH",
};

interface IContext {
  languages: ILanguage[];
  flatenedData: IFilterData;
  menuData: IMenuData | null;
  baseUrl: string;
  init: (type: keyof typeof refreshState) => Promise<void>;
  isError: boolean;
  theme: Theme;
  user: string;
  clientCode: string;
  sessionKey: string;
  accountLang: string;
  renderFlag: (type: string, size?: number) => JSX.Element;
  isCloseAppDropDownsFromApp: boolean;
  setIsCloseAppDropDownsFromApp: (value: React.SetStateAction<boolean>) => void;
  isGlobalSearchVisible: boolean;
  setMode: React.Dispatch<React.SetStateAction<Mode>>;
  setIsGlobalSearchVisible: React.Dispatch<React.SetStateAction<boolean>>;
  mode: Mode;
}

const initialState: IContext = {
  languages: [],
  flatenedData: { quickLinks: [], mainItems: [] },
  menuData: null,
  baseUrl: "",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init: async () => {},
  isError: false,
  theme: "dark",
  user: "",
  clientCode: "",
  sessionKey: "",
  accountLang: "",
  isCloseAppDropDownsFromApp: false,
  isGlobalSearchVisible: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsCloseAppDropDownsFromApp: () => {},
  renderFlag: () => <div></div>,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setMode: () => {},
  mode: "system",
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsGlobalSearchVisible: () => {},
};

const AppStateContext = createContext<IContext>(initialState);

export const AppStateContextProvider: React.FC<IMainProps> = ({
  clientCode,
  sessionKey,
  accountLang,
  user,
  children,
  // isCloseComDropDown,
  // isGlobalSearchVisible,
}) => {
  const [languages, setLanguages] = useState<ILanguage[]>([]);
  const [flatenedData, setFlatenedData] = useState<IFilterData>({
    quickLinks: [],
    mainItems: [],
  });
  const [menuData, setMenuData] = useState<IMenuData | null>(null);
  const [lastVistedPage, setLastVistedPage] = useState("");
  const [baseUrl, setBaseUrl] = useState("");
  const [isError, setIsError] = useState(false);
  const [isCloseAppDropDownsFromApp, setIsCloseAppDropDownsFromApp] =
    useState(false);
  // const [first, setfirst] = useState(second)
  const [isGlobalSVisible, setIsGlobalSearchVisible] = useState(false);
  // eslint-disable-next-line
  const [newMenuItem, setNewMenuItem] = useState<INewMenuItem | null>(null);

  const { mode, setMode, theme } = useTheme();

  const init = async (type: keyof typeof refreshState) => {
    setIsError(false);
    const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;
    const langPhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-lang`;
    const newItemPhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new-item`;

    sessionStorage.setItem(newItemPhrase, JSON.stringify([]));

    try {
      const services = await requestERPLYData({
        clientCode,
        request: "getServiceEndpoints",
        partnerKey,
      });
      if (services) {
        if (services.status.responseStatus === "error") {
          const value = sessionStorage.getItem(cachePhrase);
          const savedMenu = JSON.parse(
            value ? value : JSON.stringify("")
          ) as IMenuData;
          if (savedMenu) {
            if (savedMenu.system.languages.length) {
              setLanguages(
                createLanguageData(
                  savedMenu.system.languages,
                  savedMenu.system.homeMenuItem.targetUrl,
                  accountLang,
                  lastVistedPage
                )
              );
            } else {
              setLanguages([]);
            }
            if (newMenuItem) {
              savedMenu.items =
                addNewMenuItem(savedMenu.items, newMenuItem) || [];
              sessionStorage.setItem(cachePhrase, JSON.stringify(savedMenu));
            }
            // this.menuData = savedMenu;
            setMenuData(savedMenu);
            setFlatenedData(flatenArray(savedMenu.items));
            // this.render(savedMenu);
          } else {
            // this.renderError();
            setMenuData(null);
            setIsError(true);
            setLanguages([]);
          }
        } else {
          const baseUrl = services.records[0].user.url;
          setBaseUrl(baseUrl);
          const response = await fetch(
            `${baseUrl}v2/user-menu?language=${accountLang}&regenerate=true`,
            {
              method: "GET",
              headers: {
                clientCode: clientCode,
                sessionKey: sessionKey,
              },
              credentials: "include",
            }
          );

          const data = await response.json();

          if (data && data.data) {
            const lastCall = `${clientCode}-last-load`;
            sessionStorage.setItem(
              lastCall,
              (new Date().getTime() / 1000).toString()
            );
            const result = data.data as IMenuData;

            const requestData = {
              request: "getActiveLanguages",
              clientCode,
              sessionKey,
              partnerKey,
            };

            const response = await requestERPLYData(requestData);

            if (response.status.responseStatus !== "error") {
              result.system.languages = response.records;
              sessionStorage.setItem(
                langPhrase,
                JSON.stringify(response.records)
              );
            } else {
              const value = sessionStorage.getItem(langPhrase);
              const savedLang = JSON.parse(
                value ? value : JSON.stringify("")
              ) as ILanguage[];
              if (savedLang) {
                result.system.languages = savedLang;
              } else {
                result.system.languages = [];
              }
            }

            if (type === refreshState.RELOAD) {
              if (result.system.languages.length) {
                setLanguages(
                  createLanguageData(
                    result.system.languages,
                    result.system.homeMenuItem.targetUrl,
                    accountLang,
                    lastVistedPage
                  )
                );
              } else {
                setLanguages([]);
              }
              const menuDataItem = result;
              if (newMenuItem) {
                menuDataItem.items =
                  addNewMenuItem(menuDataItem.items, newMenuItem) || [];
              }

              setMenuData(menuDataItem);
              // this.render(this.menuData);
              setFlatenedData(flatenArray(menuDataItem.items));
              sessionStorage.setItem(cachePhrase, JSON.stringify(menuDataItem));
            } else if (type === refreshState.MAIN) {
              if (result.system.languages.length) {
                setLanguages(
                  createLanguageData(
                    result.system.languages,
                    result.system.homeMenuItem.targetUrl,
                    accountLang,
                    lastVistedPage
                  )
                );
              } else {
                setLanguages([]);
              }

              const menuDataItem = result;
              setMenuData(menuDataItem);
              // this.menuData = result;
              // this.render(this.menuData);
              setFlatenedData(flatenArray(menuDataItem.items));
              sessionStorage.setItem(cachePhrase, JSON.stringify(menuDataItem));
              // console.log("menuData", result);
            } else if (type === refreshState.REFRESH) {
              if (result.system.languages.length) {
                setLanguages(
                  createLanguageData(
                    result.system.languages,
                    result.system.homeMenuItem.targetUrl,
                    accountLang,
                    lastVistedPage
                  )
                );
              } else {
                setLanguages([]);
              }
              // this.menuData = result;
              // this.render(this.menuData);
              const menuDataItem = result;
              setMenuData(menuDataItem);
              setFlatenedData(flatenArray(menuDataItem.items));
              sessionStorage.setItem(cachePhrase, JSON.stringify(menuDataItem));
              window.location.reload();
            }

            // this.getNotifications();
          } else {
            const value = sessionStorage.getItem(cachePhrase);
            const savedMenu = JSON.parse(
              value ? value : JSON.stringify("")
            ) as IMenuData;
            if (savedMenu) {
              if (savedMenu.system.languages.length) {
                setLanguages(
                  createLanguageData(
                    savedMenu.system.languages,
                    savedMenu.system.homeMenuItem.targetUrl,
                    accountLang,
                    lastVistedPage
                  )
                );
              } else {
                setLanguages([]);
              }
              if (newMenuItem) {
                savedMenu.items =
                  addNewMenuItem(savedMenu.items, newMenuItem) || [];
                sessionStorage.setItem(cachePhrase, JSON.stringify(savedMenu));
              }
              setMenuData(savedMenu);
              setFlatenedData(flatenArray(savedMenu.items));
              // this.render(savedMenu);
              // this.getNotifications();
            } else {
              // this.renderError();
              setMenuData(null);
              setIsError(true);
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
      const value = sessionStorage.getItem(cachePhrase);
      const savedMenu = JSON.parse(
        value ? value : JSON.stringify("")
      ) as IMenuData;
      if (savedMenu) {
        if (savedMenu.system.languages.length) {
          setLanguages(
            createLanguageData(
              savedMenu.system.languages,
              savedMenu.system.homeMenuItem.targetUrl,
              accountLang,
              lastVistedPage
            )
          );
        } else {
          setLanguages([]);
        }

        // this.menuData = savedMenu;
        // this.flatMenuData = flatenArray(savedMenu.items);
        setMenuData(savedMenu);
        setFlatenedData(flatenArray(savedMenu.items));
        // this.render(savedMenu);
      } else {
        // this.renderError();
        setMenuData(null);
        setIsError(true);
      }
    }
  };

  useEffect(() => {
    createStyle();
  }, []);

  useEffect(() => {
    // handle keyboard shortcut for opening and closing global search
    document.addEventListener("keydown", (e) => {
      let handled = false;

      if (e.key !== undefined && e.key.toLowerCase() === "k" && e.metaKey) {
        // element.isCloseComDropDown = false;
        setIsCloseAppDropDownsFromApp(false);

        // element.isGlobalSearchVisible = true;
        setIsGlobalSearchVisible(true);
        handled = true;
      } else if (e.keyCode !== undefined && e.keyCode === 75 && e.metaKey) {
        // element.isCloseComDropDown = false;
        setIsCloseAppDropDownsFromApp(false);
        setIsGlobalSearchVisible(true);
        // element.isGlobalSearchVisible = true;
        handled = true;
      } else if (e.key === "Escape") {
        handled = true;
        // element.isGlobalSearchVisible = false;
        // element.isCloseComDropDown = true;
        setIsGlobalSearchVisible(false);
        setIsCloseAppDropDownsFromApp(true);
      }

      if (handled) {
        // Suppress "double action" if event handled
        e.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    const lastVisited =
      localStorage.getItem(`erply_last_page_${clientCode}`) || ""; // localStorage storage used because this is been set by another application.

    setLastVistedPage(lastVisited);
  }, [clientCode]);

  useEffect(() => {
    if (clientCode && sessionKey && accountLang) {
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;
      const lastVisited =
        localStorage.getItem(`erply_last_page_${clientCode}`) || ""; // localStorage storage used because this is been set by another application.

      const value = sessionStorage.getItem(cachePhrase);
      const savedMenu = JSON.parse(
        value ? value : JSON.stringify("")
      ) as IMenuData;

      const currentTime = new Date().getTime() / 1000;
      const lastCallKey = `${clientCode}-last-load`;
      const lastLoadValue = sessionStorage.getItem(lastCallKey);
      const lastLoad = JSON.parse(
        lastLoadValue ? lastLoadValue : JSON.stringify("")
      ) as number;

      if (savedMenu) {
        if (lastLoad && currentTime - lastLoad >= 300) {
          init("RELOAD");
        } else {
          if (savedMenu.system.languages.length) {
            setLanguages(
              createLanguageData(
                savedMenu.system.languages,
                savedMenu.system.homeMenuItem.targetUrl,
                accountLang,
                lastVisited
              )
            );
          }

          const menuDataItem = savedMenu;
          setMenuData(menuDataItem);
          setFlatenedData(flatenArray(menuDataItem.items));
          // this.render(savedMenu);
          // this.getNotifications();
        }
      } else {
        init("MAIN");
      }
    } else if (clientCode && !sessionKey && accountLang) {
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;
      const lastVisited =
        localStorage.getItem(`erply_last_page_${clientCode}`) || ""; // localStorage storage used because this is been set by another application.

      const value = sessionStorage.getItem(cachePhrase);
      const savedMenu = JSON.parse(
        value ? value : JSON.stringify("")
      ) as IMenuData;

      if (savedMenu) {
        if (savedMenu.system.languages.length) {
          setLanguages(
            createLanguageData(
              savedMenu.system.languages,
              savedMenu.system.homeMenuItem.targetUrl,
              accountLang,
              lastVisited
            )
          );
        }

        // this.menuData = savedMenu;
        // this.flatMenuData = flatenArray(savedMenu.items);
        const menuDataItem = savedMenu;
        setMenuData(menuDataItem);
        setFlatenedData(flatenArray(menuDataItem.items));
        // this.render(savedMenu);
        // this.getNotifications();
      } else {
        init("MAIN");
      }
    }

    // eslint-disable-next-line
  }, [clientCode, sessionKey, user, accountLang]);

  // useEffect(() => {
  //   const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;

  //   const value = sessionStorage.getItem(cachePhrase);
  //   const savedMenu = JSON.parse(
  //     value ? value : JSON.stringify("")
  //   ) as IMenuData;
  //   window.addEventListener("addMenuItem", (e) => {
  //     const customEvent = e as CustomEvent<INewMenuItem>;

  //     const newItem = customEvent.detail;

  //     if (newItem) {
  //       // console.log("newMenuItem", newItem);

  //       if (savedMenu) {
  //         savedMenu.items = addNewMenuItem(savedMenu.items, newItem) || [];
  //         sessionStorage.setItem(cachePhrase, JSON.stringify(savedMenu));
  //         setMenuData(savedMenu);
  //       } else if (menuData) {
  //         const item = { ...menuData };
  //         item.items = addNewMenuItem(item.items, newItem) || [];
  //         sessionStorage.setItem(cachePhrase, JSON.stringify(item));
  //         setMenuData(item);
  //       }
  //     }
  //     // element.newMenuItem = e.detail;
  //   });

  //   // eslint-disable-next-line
  // }, []);

  // const handleAddNewItem = useCallback(
  //   (newMenuItems: INewMenuItem[]) => {
  //     const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;

  //     const value = sessionStorage.getItem(cachePhrase);
  //     const savedMenu = JSON.parse(
  //       value ? value : JSON.stringify("")
  //     ) as IMenuData;

  //     if (newMenuItems.length) {
  //       if (savedMenu) {
  //         // savedMenu.items = addNewMenuItem(savedMenu.items, newMenuItem) || [];
  //         const newMenuData = addItemsInBulk(newMenuItems, savedMenu);
  //         sessionStorage.setItem(cachePhrase, JSON.stringify(newMenuData));
  //         setMenuData(JSON.parse(JSON.stringify(newMenuData)));
  //       } else if (menuData) {
  //         // const item = { ...menuData };
  //         // item.items = addNewMenuItem(item.items, newMenuItem) || [];
  //         const newMenuData = addItemsInBulk(newMenuItems, menuData);
  //         sessionStorage.setItem(cachePhrase, JSON.stringify(newMenuData));
  //         setMenuData(JSON.parse(JSON.stringify(newMenuData)));
  //       }
  //     }
  //   },
  //   [clientCode, accountLang, user, setMenuData, menuData]
  // );

  const addNewItem = useCallback(
    (newMenuItem: INewMenuItem) => {
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new`;

      const value = sessionStorage.getItem(cachePhrase);
      const savedMenu = JSON.parse(
        value ? value : JSON.stringify("")
      ) as IMenuData;

      if (newMenuItem) {
        if (savedMenu) {
          savedMenu.items = addNewMenuItem(savedMenu.items, newMenuItem) || [];
          sessionStorage.setItem(cachePhrase, JSON.stringify(savedMenu));
          setMenuData(JSON.parse(JSON.stringify(savedMenu)));
        } else if (menuData) {
          const item = JSON.parse(JSON.stringify(menuData));
          item.items = addNewMenuItem(item.items, newMenuItem) || [];
          // const newMenuData = addItemsInBulk(item, menuData);
          sessionStorage.setItem(cachePhrase, JSON.stringify(item));
          setMenuData(JSON.parse(JSON.stringify(item)));
        }
      }
    },
    [clientCode, accountLang, user, setMenuData, menuData]
  );
  useEffect(() => {
    document.addEventListener("addMenuItem", (e) => {
      const customEvent = e as CustomEvent<INewMenuItem>;
      const newItem = customEvent.detail;
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new-item`;
      const value = sessionStorage.getItem(cachePhrase);
      const savedNewItems = JSON.parse(
        value ? value : JSON.stringify("")
      ) as INewMenuItem[];
      if (newItem) {
        if (savedNewItems && Array.isArray(savedNewItems)) {
          const isFound = savedNewItems.find(
            (e) => e.item.id === newItem.item.id
          );
          if (!isFound) {
            savedNewItems.push(newItem);
            sessionStorage.setItem(cachePhrase, JSON.stringify(savedNewItems));
          }
        } else {
          sessionStorage.setItem(cachePhrase, JSON.stringify([newItem]));
        }
        // setNewMenuItem(newItem);
        addNewItem(newItem);
        console.log("newItem-doc", newItem);
      }
    });
  }, [addNewItem, clientCode, user, accountLang]);

  useEffect(() => {
    // listen to event to add new menuItem
    window.addEventListener("addMenuItem", (e) => {
      const customEvent = e as CustomEvent<INewMenuItem>;
      const newItem = customEvent.detail;
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new-item`;
      const value = sessionStorage.getItem(cachePhrase);
      const savedNewItems = JSON.parse(
        value ? value : JSON.stringify("")
      ) as INewMenuItem[];
      if (newItem) {
        if (savedNewItems && Array.isArray(savedNewItems)) {
          const isFound = savedNewItems.find(
            (e) => e.item.id === newItem.item.id
          );
          if (!isFound) {
            savedNewItems.push(newItem);
            sessionStorage.setItem(cachePhrase, JSON.stringify(savedNewItems));
          }
        } else {
          sessionStorage.setItem(cachePhrase, JSON.stringify([newItem]));
        }
        // setNewMenuItem(newItem);
        addNewItem(newItem);
        console.log("newItem-win", newItem);
      }
    });
  }, [addNewItem, clientCode, user, accountLang]);

  useEffect(() => {
    const interval = setInterval(() => {
      const cachePhrase = `${clientCode}-${user?.trim()}-${accountLang?.trim()}-${user?.trim()}-new-item`;
      const value = sessionStorage.getItem(cachePhrase);
      const savedNewItems = JSON.parse(
        value ? value : JSON.stringify("")
      ) as INewMenuItem[];

      if (
        savedNewItems &&
        Array.isArray(savedNewItems) &&
        savedNewItems.length
      ) {
        savedNewItems.forEach((item) => {
          addNewItem(item);
        });
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [clientCode, user, accountLang, addNewItem]);

  // useEffect(() => {
  //   if (newMenuItem) {
  //     addNewItem(newMenuItem);
  //   }

  //   // eslint-disable-next-line
  // }, [newMenuItem, addNewItem]);

  // useEffect(() => {
  //   setIsCloseAppDropDownsFromApp(isCloseComDropDown);
  // }, [isCloseComDropDown]);

  const renderFlag = (type: string, size?: number) => {
    // switch (type) {
    //   case "en":
    //     return <GBFlag />;

    //   case "et":
    //     return <EEFlag />;

    //   case "ru":
    //     return <RUFlag />;

    //   case "fi":
    //     return <FIFlag />;

    //   default:
    //     return <FeatherIcon icon='globe' />;
    // }
    return <FeatherIcon icon='globe' size={size} />;
  };

  return (
    <AppStateContext.Provider
      value={{
        languages,
        flatenedData,
        menuData,
        baseUrl,
        init,
        isError,
        theme,
        setMode,
        mode,
        user,
        clientCode,
        sessionKey,
        accountLang,
        renderFlag,
        isCloseAppDropDownsFromApp,
        setIsCloseAppDropDownsFromApp,
        isGlobalSearchVisible: isGlobalSVisible,
        setIsGlobalSearchVisible,
      }}
    >
      {children}
    </AppStateContext.Provider>
  );
};

export const useAppState = () => useContext(AppStateContext);
